import { c as _c } from "react/compiler-runtime";
import { PasswordFieldPropertiesType } from "@website/widget/password-field/password-field.types";
import { checkPasswordConditionErrors } from "@website/widget/password-field/password-field.utils";
import { ChangeEvent, useEffect, useState } from "react";
export const usePasswordField = properties => {
  const $ = _c(12);
  const {
    initialValue: t0,
    onChange
  } = properties;
  const initialValue = t0 === undefined ? "" : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      useEnglishCharacter: true,
      useNumberCharacter: true,
      useSpecialCharacter: true,
      reachMinimumCharactersLength: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [conditionErrors, setConditionErrors] = useState(t1);
  const [password, setPassword] = useState(initialValue);
  const [visibility, setVisibility] = useState(false);
  let t2;
  let t3;
  if ($[1] !== initialValue) {
    t2 = () => {
      const errors = checkPasswordConditionErrors(initialValue);
      setConditionErrors(errors);
    };
    t3 = [initialValue];
    $[1] = initialValue;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== onChange) {
    t4 = event => {
      const {
        value
      } = event.target;
      const errors_0 = checkPasswordConditionErrors(value);
      setConditionErrors(errors_0);
      setPassword(value);
      onChange?.(value);
      if (Object.values(errors_0).every(_temp)) {
        onChange?.(value);
      }
    };
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onChangePassword = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setVisibility(_temp2);
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const toggleVisibility = t5;
  let t6;
  if ($[7] !== conditionErrors || $[8] !== onChangePassword || $[9] !== password || $[10] !== visibility) {
    t6 = {
      password,
      onChangePassword,
      conditionErrors,
      toggleVisibility,
      visibility
    };
    $[7] = conditionErrors;
    $[8] = onChangePassword;
    $[9] = password;
    $[10] = visibility;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp(value_0) {
  return value_0 === false;
}
function _temp2(value_1) {
  return !value_1;
}